import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { IconChipComponent } from '@principle-theorem/ng-principle-shared';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { ICustomReportDefinedColumn } from '@principle-theorem/principle-core/interfaces';
import { ReportBuilderDataPoint } from '@principle-theorem/reporting';

@Component({
  selector: 'pr-reporting-datapoint',
  templateUrl: './reporting-datapoint.component.html',
  styleUrls: ['./reporting-datapoint.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTooltip, NgCommonModule, IconChipComponent],
})
export class ReportingDatapointComponent {
  label: Signal<string>;
  icon: Signal<string>;

  column = input.required<ICustomReportDefinedColumn>();

  constructor() {
    this.label = computed(() =>
      ReportBuilderDataPoint.getLabel(
        this.column().measure,
        this.column().label
      )
    );
    this.icon = computed(() =>
      ReportBuilderDataPoint.getIcon(this.column().measure)
    );
  }
}
